// @ts-ignore
import chroma from "chroma-js";

export default function getLuminosities(colors: string[]) {
  return colors
    .map((color) => {
      return {
        color,
        luminosity: chroma(color).jch()[0],
      };
    })
    .sort((a, b) => (a.luminosity < b.luminosity ? 1 : -1))
    .map((node) => node.luminosity);
}
